var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEinfacheHandhabungDaKennzeichnungsfrei = function SvgEinfacheHandhabungDaKennzeichnungsfrei(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Einfache_Handhabung_da_kennzeichnungsfrei_svg__Ebene_2",
    viewBox: "0 0 105.76 105.76"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Einfache_Handhabung_da_kennzeichnungsfrei_svg__cls-1{fill:currentColor}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Einfache_Handhabung_da_kennzeichnungsfrei_svg__Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.88 105.76 0 52.88 52.88 0l52.88 52.88zM2.51 52.88l50.37 50.37 50.37-50.37L52.88 2.51z",
    className: "Einfache_Handhabung_da_kennzeichnungsfrei_svg__cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.88 90.1 15.66 52.88l37.22-37.22L90.1 52.88zm-34.7-37.22 34.71 34.71L87.6 52.88 52.88 18.17z",
    className: "Einfache_Handhabung_da_kennzeichnungsfrei_svg__cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.99 1.26h1.78v16.75h-1.78zM51.99 88.84h1.78v15.66h-1.78zM1.26 51.99h15.66v1.78H1.26zM89.1 13.97 12.38 86.64l-.36.34 2.87 3.03L91.6 17.35l.37-.35z",
    className: "Einfache_Handhabung_da_kennzeichnungsfrei_svg__cls-1"
  }))));
};
export default SvgEinfacheHandhabungDaKennzeichnungsfrei;